import {AfterViewInit, ChangeDetectorRef, Component} from '@angular/core';
import {EmployeeService} from '../../../../service/employee.service';
import {EmployeeEvent} from '../../../../event/employee.event';
import {EmployeeApiModel} from '../../../../model/employee-api.model';
import {EmployeeEventTypeEnum} from '../../../../enum/employee-event-type.enum';

/**
 * @class
 * @description This class is responsible for rendering the employee information component.
 * @export
 * @name InformationEmployeePartialLayoutComponent
 */
@Component({
  imports: [
  ],
  selector: 'app-layout-partial-employee-information',
  standalone: true,
  styleUrl: './information.component.scss',
  templateUrl: './information.component.html'
})
export class InformationEmployeePartialLayoutComponent implements AfterViewInit {

  /**
   * @description This property contains the default employee information.
   * @memberof InformationEmployeePartialLayoutComponent
   * @name InformationEmployeePartialLayoutComponent#employee
   * @property
   * @protected
   * @type {EmployeeApiModel?}
   */
  protected employee?: EmployeeApiModel;

  /**
   * @constructor
   * @description This method instantiates a new instance of our employee information component.
   * @memberof InformationEmployeePartialLayoutComponent
   * @name InformationEmployeePartialLayoutComponent#constructor
   * @param {ChangeDetectorRef} changeDetector The change detector reference.
   * @param {EmployeeService} employeeService The employee service provider.
   * @public
   */
  public constructor(
    /**
     * @description This property contains the change detector reference.
     * @memberof InformationEmployeePartialLayoutComponent
     * @name InformationEmployeePartialLayoutComponent#changeDetector
     * @private
     * @property
     * @readonly
     * @type {ChangeDetectorRef}
     */
    private readonly changeDetector: ChangeDetectorRef,
    /**
     * @description This property contains the employee service provider.
     * @memberof InformationEmployeePartialLayoutComponent
     * @name InformationEmployeePartialLayoutComponent#changeDetector
     * @private
     * @property
     * @readonly
     * @type {EmployeeService}
     */
    private readonly employeeService: EmployeeService
  ) {
  }

  /**
   * @abstract
   * @description This method executes after the view has been initialized and all elements are in place.
   * @memberof InformationEmployeePartialLayoutComponent
   * @method
   * @name InformationEmployeePartialLayoutComponent@ngAfterViewInit
   * @public
   * @returns {void}
   */
  public ngAfterViewInit(): void {

    // Subscribe to the appropriate events of the employee service.
    this.employeeService.events.subscribe((e: EmployeeEvent): void => {
      // Check for a session-started event then load the employee details.
      if (e.type === EmployeeEventTypeEnum.SessionStart) this.employeeService.details().subscribe(
        (e: EmployeeApiModel): void => {

          // Reset the employee object into the component instance.
          this.employee = e;

          // Have our change detector detect any changes.
          this.changeDetector.detectChanges();
        }
      );
    });
  }
}
